import React, { FC } from "react";
import { Modal, notification } from "antd";
import { useIntl } from "react-intl";
import { AveliosButton } from "../common-layout/avelios-button";
import { Maybe } from "@graphql-tools/utils/typings/types";
import {
  Resource_AppointmentRequestStatus,
  useRejectAppointmentProposalsMutation,
} from "../../src/generated/graphql";

interface RejectAppointmentProposalsModalProps {
  open: boolean;
  onClose: () => void;
  clinicId: Maybe<string> | undefined;
  appointmentRequestId: Maybe<string> | undefined;
}

export const RejectAppointmentProposalsModal: FC<
  RejectAppointmentProposalsModalProps
> = ({ open, onClose, appointmentRequestId, clinicId }) => {
  const { formatMessage } = useIntl();

  const [rejectAppointmentProposals] = useRejectAppointmentProposalsMutation({
    onCompleted: (data) => {
      if (
        data.rejectAppointmentProposals?.appointmentRequest?.status ===
        Resource_AppointmentRequestStatus.AppointmentRequestStatusProposalRejected
      ) {
        notification.info({
          message: formatMessage({ id: "appointment-proposal.reject.info" }),
        });
        onClose();
      } else {
        notification.error({
          message: formatMessage({ id: "notification.error" }),
        });
      }
    },
  });

  const handleReject = () => {
    if (appointmentRequestId && clinicId) {
      rejectAppointmentProposals({
        variables: { appointmentRequestId, clinicId },
      });
    }
  };
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={
        <AveliosButton
          disabled={!clinicId || !appointmentRequestId}
          type={"primary"}
          danger
          onClick={handleReject}
        >
          {formatMessage({ id: "appointment-proposal.reject" })}
        </AveliosButton>
      }
      title={formatMessage({ id: "appointment-proposal.reject.title" })}
    >
      <p>{formatMessage({ id: "appointment-proposal.reject.description" })}</p>
    </Modal>
  );
};
